import { inject, Pipe, type PipeTransform } from '@angular/core';

import { PRIMITIVE_MULTI_TABLE_WORDINGS } from '../../primitive-multi-table.wordings';

@Pipe({
  name: 'emptyTranslate',
})
export class EmptyTranslatePipe implements PipeTransform {
  private readonly _wordings = inject(PRIMITIVE_MULTI_TABLE_WORDINGS);

  public transform(filterStatus: boolean | string): string {
    if (typeof filterStatus === 'string') {
      return filterStatus;
    }

    const table = this._wordings._library.table;

    return filterStatus ? table.noDataFiltered() : table.noData();
  }
}
